/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { BsTypeEnum } from './BsTypeEnum';
import { str_int_float_bool_object_array_null } from './str_int_float_bool_object_array_null';
export type BodyEvent = {
    readonly id: string;
    readonly created_date: string;
    readonly bs_type: BsTypeEnum;
    /**
     * Related `Camera` id
     */
    readonly camera: number;
    /**
     * Related `CameraGroup` id
     */
    readonly camera_group: number;
    /**
     * Related `Case` id
     */
    readonly case: number;
    readonly thumbnail: string;
    readonly fullframe: string;
    readonly matched_card: number | null;
    readonly verbose_matched_card: Record<string, str_int_float_bool_object_array_null> | null;
    readonly matched_cluster: number | null;
    readonly matched_object: string;
    readonly matched_lists: Array<number | null>;
    readonly episode: number | null;
    readonly video_archive: number | null;
    acknowledged?: boolean;
    readonly acknowledged_date: string;
    readonly acknowledged_by: number | null;
    acknowledged_reaction?: string;
    readonly frame_coords_left: number;
    readonly frame_coords_top: number;
    readonly frame_coords_right: number;
    readonly frame_coords_bottom: number;
    readonly matched: boolean;
    readonly detector_params: Record<string, str_int_float_bool_object_array_null>;
    readonly looks_like_confidence: number | null;
    readonly confidence: number;
    readonly cluster_confidence: number;
    readonly quality: number;
    readonly features: Record<string, str_int_float_bool_object_array_null>;
    readonly external_detector: boolean;
    readonly line: number | null;
    readonly line_crossing_direction: string | null;
    readonly backward_line_crossing: boolean;
    readonly meta: Record<string, str_int_float_bool_object_array_null>;
    readonly latitude: number | null;
    readonly longitude: number | null;
};
export const EmptyBodyEvent: BodyEvent = {
    id: '',
    created_date: '',
    bs_type: BsTypeEnum.OVERALL,
    /**
     * Related `Camera` id
     */
    camera: 0,
    /**
     * Related `CameraGroup` id
     */
    camera_group: 0,
    /**
     * Related `Case` id
     */
    case: 0,
    thumbnail: '',
    fullframe: '',
    matched_card: null,
    verbose_matched_card: null,
    matched_cluster: null,
    matched_object: '',
    matched_lists: [],
    episode: null,
    video_archive: null,
    acknowledged: false,
    acknowledged_date: '',
    acknowledged_by: null,
    acknowledged_reaction: '',
    frame_coords_left: 0,
    frame_coords_top: 0,
    frame_coords_right: 0,
    frame_coords_bottom: 0,
    matched: false,
    detector_params: {},
    looks_like_confidence: null,
    confidence: 0,
    cluster_confidence: 0,
    quality: 0,
    features: {},
    external_detector: false,
    line: null,
    line_crossing_direction: null,
    backward_line_crossing: false,
    meta: {},
    latitude: null,
    longitude: null,
};